import { inject } from "@angular/core";
import { LockSessionService } from "../services/auth/lock-session.service";
import { UserStorageService } from "../services/local/user-storage.service";
import { CanActivateFn } from "@angular/router";

export const LockGuard: CanActivateFn = (route, state) => {
    const userStorageService = inject(UserStorageService);
    const lockSessionService = inject(LockSessionService);
    
    if (lockSessionService.timeOut.asMilliseconds() > 0) {
        lockSessionService.detectInactivity().subscribe(res => {
            if (res) {
                lockSessionService.finalizeLock();
                userStorageService.setLock(false);
            }
        });
    }    
    return true;
};

